<template>
  <label class="block font-semibold text-navy flex-1">
    <slot/>
  </label>
</template>
